//
//
//
//
import FormComponent from './form.vue';
export default {
  name: 'order-consign-return-create',
  props: {
    id: {
      type: String,
      required: false
    }
  },
  components: {
    FormComponent: FormComponent
  }
};